import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { NotificationProvider } from './NotificationContext';
import { FeaturesProvider, useFeatures } from './FeaturesContext';
import Layout from './components/Layout';
import LoginPage from './pages/Auth/Login';
import ResetPassword from './pages/Auth/ResetPassword';
import HomePage from './pages/Home';
import Dashboard from './pages/Dashboard';
import Planning from './pages/Planning';
import ModifPlanning from './pages/ModifPlanning';
import MonPlanningHebdo from './pages/MonPlanningHebdo';
import ProtectedRoute from './components/ProtectedRoute';
import AddShiftsRequests from './pages/AddShiftsRequests';
import GestionShifts from './pages/GestionShifts';
import Demandes from './pages/Demandes';
import Conges from './pages/Conges';
import GestionUtilisateurs from './pages/GestionUtilisateurs';
import VueJournee from './pages/VueJournee';
import VueMensuelle from './pages/VueMensuelle';
import DashboardAnalyse from './pages/DashboardAnalyse';
import PayslipsPage from './pages/PayslipsPage';
import GestionHeuresSup from './pages/GestionHeuresSup';
import SoldesConges from './pages/SoldesConges';
import HistoriqueContractuel from './pages/HistoriqueContractuel';

import AuthInterceptor from './components/AuthInterceptor';

function AppRoutes() {
  const features = useFeatures();
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="reset-password" element={<ResetPassword />} />

        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="planning"
          element={
            <ProtectedRoute>
              <Planning />
            </ProtectedRoute>
          }
        />
        <Route
          path="modifPlanning"
          element={
            <ProtectedRoute>
              <ModifPlanning />
            </ProtectedRoute>
          }
        />
        <Route
          path="monPlanningHebdo"
          element={
            <ProtectedRoute>
              <MonPlanningHebdo />
            </ProtectedRoute>
          }
        />
        <Route
          path="addShiftsRequests"
          element={
            <ProtectedRoute>
              <AddShiftsRequests />
            </ProtectedRoute>
          }
        />
        <Route
          path="gestionShifts"
          element={
            <ProtectedRoute>
              <GestionShifts />
            </ProtectedRoute>
          }
        />
        <Route
          path="gestionShifts/jour/:date"
          element={
            <ProtectedRoute teamLeaderAndAbove>
              <VueJournee />
            </ProtectedRoute>
          }
        />
        <Route
          path="vueMensuelle"
          element={
            <ProtectedRoute teamLeaderAndAbove>
              <VueMensuelle />
            </ProtectedRoute>
          }
        />
        <Route
          path="demandes"
          element={
            <ProtectedRoute>
              <Demandes />
            </ProtectedRoute>
          }
        />
        <Route
          path="conges"
          element={
            <ProtectedRoute>
              <Conges />
            </ProtectedRoute>
          }
        />
        {features.payslips && (
          <Route
            path="payslips"
            element={
              <ProtectedRoute>
                <PayslipsPage />
              </ProtectedRoute>
            }
          />
        )}
        <Route
          path="heuresSup"
          element={
            <ProtectedRoute>
              <GestionHeuresSup />
            </ProtectedRoute>
          }
        />
        <Route
          path="soldesConges"
          element={
            <ProtectedRoute managerOnly>
              <SoldesConges />
            </ProtectedRoute>
          }
        />
        <Route
          path="analyse"
          element={
            <ProtectedRoute managerOnly>
              <DashboardAnalyse />
            </ProtectedRoute>
          }
        />
        <Route
          path="utilisateurs"
          element={
            <ProtectedRoute>
              <GestionUtilisateurs />
            </ProtectedRoute>
          }
        />
        <Route
          path="utilisateurs/:userId/contrat"
          element={
            <ProtectedRoute managerOnly>
              <HistoriqueContractuel />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AuthInterceptor />
      <NotificationProvider>
        <FeaturesProvider>
          <Router>
            <AppRoutes />
          </Router>
        </FeaturesProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
